import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { ConfirmationService, ConfirmEventType, MenuItem, MessageService, SelectItem } from 'primeng/api';
import { filter } from 'rxjs';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { CompanyGateway } from 'src/app/application/gateway/CompanyGateway';
import { ConsigneeGateway } from 'src/app/application/gateway/ConsigneeGateway';
import { CountryGateway } from 'src/app/application/gateway/CountryGateway';
import { DirectSaleProgramGateway } from 'src/app/application/gateway/DirectSaleProgramGateway';
import { ExportOfferGateway } from 'src/app/application/gateway/ExportOfferGateway';
import { FridgeStorageGateway } from 'src/app/application/gateway/FridgeStorageGateway';
import { ImportOrderGateway } from 'src/app/application/gateway/ImportOrderGateway';
import { NotifierGateway } from 'src/app/application/gateway/NotifierGateway';
import { PortGateway } from 'src/app/application/gateway/PortGateway';
import { ProfileGateway } from 'src/app/application/gateway/ProfileGateway';
import { VarietyGateway } from 'src/app/application/gateway/VarietyGateway';
import { Company } from 'src/app/domain/models/Company';
import { Consignee } from 'src/app/domain/models/Consignee';
import { Country } from 'src/app/domain/models/Country';
import { AddImportoOrderToProgramWeek, ProgramYearSeries } from 'src/app/domain/models/DirectSaleProgram';
import { AddOrderClosedSaleRequest, ExportOffer } from 'src/app/domain/models/ExportOffer';
import { FridgeStorage } from 'src/app/domain/models/FridgeStorage';
import { ClosedSaleWeek, ClosedSaleWeekRequest, ImportOrder, ImportOrderDetail, ImportOrderInformation } from 'src/app/domain/models/ImportOrder';
import { Notifier } from 'src/app/domain/models/Notifier';
import { Packaging } from 'src/app/domain/models/Packaging';
import { PalletInstructiveFormat, PalletPrice } from 'src/app/domain/models/Pallet';
import { Port } from 'src/app/domain/models/Port';
import { ProductCertificateType } from 'src/app/domain/models/ProductCertificateType';
import { Importer, Profile } from 'src/app/domain/models/Profile';
import { ProgramRequestInformation } from 'src/app/domain/models/ProgramRequest';
import { Species } from 'src/app/domain/models/Species';
import { BasicUser } from 'src/app/domain/models/User';
import { Variety } from 'src/app/domain/models/Variety';
import { Routes } from 'src/app/infrastructure/routes';
import { isDivisor } from 'src/app/ui/util/custom-validators';
import { ErrorMessageUtil } from 'src/app/ui/util/error-message-util';
import { formLimit } from 'src/app/ui/util/form-limit';
import { OrderUtils } from 'src/app/ui/util/order-utils';
import { ProgramRequestUtil } from 'src/app/ui/util/programRequestUtil';
import { SessionVarUtils } from 'src/app/ui/util/session-var-util';
import { SpeciesUtils } from 'src/app/ui/util/species-utils';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-exporter-closed-sale-orders',
  templateUrl: './exporter-closed-sale-orders.component.html',
  styleUrls: ['./exporter-closed-sale-orders.component.css'],
  providers: [ConfirmationService]
})
export class ExporterClosedSaleOrdersComponent implements OnInit {
  breadcrumbItems: MenuItem[] = []
  breadcrumbHomeItem: MenuItem = {}

  directSaleProgramId: any | undefined
  exportOfferId: number | undefined
  exportOffer: ExportOffer | undefined
  selectedProductCertificateTypes: ProductCertificateType[] = []
  selectedPackagingTypes: Packaging[] = []

  weekDtos: ClosedSaleWeek[] = []

  startWeek: number = 0
  endWeek: number = 0
  year: number = 0
  selectedMonth: number = 0
  dateCalendar: Date = new Date()
  dateCalendarMonth: Date = new Date()

  profile: BasicUser | undefined
  selectedImporter: Profile | undefined
  selectedConsignee: Consignee | undefined
  selectedNotify: Notifier | undefined
  selectedProgramRequest: ProgramRequestInformation | undefined
  importers: Importer[] = []
  consignees: Consignee[] = []
  notifies: Notifier[] = []
  countries: Country[] = []
  ports: Port[] = []
  fridgeStorages: FridgeStorage[] = []

  programsYearInfo: ProgramYearSeries[] = []

  sortOptions: SelectItem[] = []
  companyForwarders: Company[] = []
  selectedOrderGuid: string = ""
  selectedCompanyForwarder: number | undefined
  visibleAssignForwarderDialog: boolean = false
  companyCustomAgents: Company[] = []
  selectedCompanyCustomAgent: number | undefined
  visibleAssignCustomAgentDialog: boolean = false
  visibleProgramChartDialog: boolean = false

  sortOrder!: number
  sortField!: string

  visibleCurrentPalletsPrice: boolean = false
  visibleCurrentPalletsCases: boolean = false

  offerMenuitems: MenuItem[] = []

  filterFormGroup: FormGroup = this._formBuilder.group({
    week: [null],
    speciesId: [null],
    varietyId: [null],
  })

  othersFiltersForm: FormGroup = this._formBuilder.group({
    harvestDate: [''],
    kilosPerBox: [''],
    speciesSize: [''],
    shelfLife: [''],
    price: [''],
    fridgeStorageId: ['']
  })

  species: Species[] = []
  varieties: Variety[] = []
  sidebarVisible: boolean = false

  weekQueryDtos: ClosedSaleWeek[] = []
  loading: boolean = false
  submit: boolean = false
  visibleExportOfferDialog: boolean = false
  visibleAddProgramationDialog: boolean = false
  editWeek: boolean = false
  submitWeekForm: boolean = false
  visibleEditWeek: boolean = false
  visibleAddContainers: boolean = false;
  selectedSpecies: Species | undefined
  selectedVariety: Variety | undefined
  priceView: boolean = false

  currentPrices: PalletPrice[] = []
  palletCases: PalletInstructiveFormat[] = []

  formGroup: FormGroup = this._formBuilder.group({
    palletQuantity: [20, [Validators.required, isDivisor(20)]],
    importToCountryId: [null, Validators.required],
    portToId: [null, Validators.required],
    startWeek: [null, Validators.required],
    startWeekYear: [null, Validators.required]
  })

  statuses: any[] = []

  weekFormGroup: FormGroup = this._formBuilder.group({
    importOrderId: [null, Validators.required],
    week: [null, Validators.required],
    year: [null, Validators.required]
  })

  addContainersForm: FormGroup = this._formBuilder.group({
    containersNumber: [null, Validators.required]
  })

  selectedWeek: number = 0;
  selectedYear: number = 0;

  directSaleStartWeek: number = 0
  directSaleEndWeek: number = 0
  directSaleStartYear: number = 0
  directSaleEndYear: number = 0

  orderSequence: number | undefined
  orderGuid: string | undefined
  visibleValidationDelete: boolean = false;

  labelAdd: string = ""

  formLimit = formLimit

  monthYear: string = ''

  monthName: string = ''

  customMonthNames: string[] = []
  customMonths: any[] = []


  seriesProgram:number[] = []
  seriesLoad:number[] = []
  weeksChart:number[] = []

  seriesProgramRange:number[] = []
  seriesLoadRange:number[] = []
  monthsChart: string[] = []

  searchTerm: string = '';
  filteredRegisters: any[] = []




  constructor(private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _messageService: MessageService,
    private _authService: AuthGateway,
    private _formBuilder: FormBuilder,
    private _exportOfferService: ExportOfferGateway,
    private _importOrderService: ImportOrderGateway,
    private _profileService: ProfileGateway,
    private _countryService: CountryGateway ,
    private _directSaleProgramService: DirectSaleProgramGateway ,
    private _consigneeService: ConsigneeGateway,
    private _notifyService: NotifierGateway,
    private _portService: PortGateway,
    private _varietyService: VarietyGateway,
    private _fridgeStorageService: FridgeStorageGateway,
    private _companyService: CompanyGateway,
    private _confirmationService: ConfirmationService,
    public translate: TranslateService,
    private readonly cdRef: ChangeDetectorRef,
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.directSaleProgramId = params['directSaleProgramId']
    })
    let now = new Date()
    let saveDate = sessionStorage.getItem('_close_sale_month');
    if(saveDate)
    {
      let dateTime =  Date.parse(saveDate);
      this.dateCalendar = new Date(dateTime);
      now = this.dateCalendar
    }

    this.yearCalendar = now.getFullYear();
    this.loadProgramYearInformation(true)
    this.startWeek = this.getFirstWeek(now.getMonth(), now.getFullYear())
    this.endWeek = this.getLastWeek(now.getMonth(), now.getFullYear())
    this.year = now.getFullYear()
    this.selectedMonth = now.getMonth() +1
    this.monthIdSelected = now.getMonth() +1

  }


  getMonthSelected(index:number): string | undefined {
    if(this.customMonths){
      const obj = this.customMonths.find(item => item.id === index);
      return obj ? obj.name : undefined; // Retorna el nombre o null si no se encuentra
    }
    return undefined; // Retorna el nombre o null si no se encuentra
  }

  loadProgramRangeChartByMonth(data: any[]) {

    const seriesProgram: number[] = [];
    const seriesLoad: number[] = [];
    const months: string[] = [];

    const sortedYears = data.sort((a, b) => a.year - b.year);

    sortedYears.forEach(yearItem => {

      const sortedMonths = yearItem.programYearSeries
        .sort((a: { monthNumber: number; }, b: { monthNumber: number; }) => a.monthNumber - b.monthNumber);

      sortedMonths.forEach((month: { monthData: any; monthNumber: number; }) => {

        const monthData = month.monthData;

        const totalProgram = monthData.seriesProgram
          .reduce((acc: any, val: any) => acc + val, 0);

        const totalLoad = monthData.seriesLoad
          .reduce((acc: any, val: any) => acc + val, 0);

        const label = `${this.customMonthNames[month.monthNumber - 1]} ${yearItem.year}`;

        months.push(label);
        seriesProgram.push(totalProgram);
        seriesLoad.push(totalLoad);

      });

    });

    this.seriesProgramRange = seriesProgram;
    this.seriesLoadRange = seriesLoad;
    this.monthsChart = months;
  }

  ngOnInit(): void {
    this.profile = this._authService.getUser()

    if(this.profile) {
      let breadcrumbStep1ItemLabel1 = 'Program Management'
      let homeItemLabel = 'Program'

      switch(this.profile.lang) {
        case 'en':
          breadcrumbStep1ItemLabel1 = 'Program Management'
          homeItemLabel = 'Program'
          this.customMonthNames = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dic'
          ]
          this.customMonths = [
            {
              id:1,
              name:"January",
            },
            {
              id:2,
              name:"Febrary",
            },
            {
              id:3,
              name:"March",
            },
            {
              id:4,
              name:"April",
            },
            {
              id:5,
              name:"May",
            },
            {
              id:6,
              name:"June",
            },
            {
              id:7,
              name:"July",
            },
            {
              id:8,
              name:"August",
            },
            {
              id:9,
              name:"September",
            },
            {
              id:10,
              name:"October",
            },
            {
              id:11,
              name:"November",
            },
            {
              id:12,
              name:"December",
            }
          ]
          break
        case 'es':
          breadcrumbStep1ItemLabel1 = 'Gestión de Programación'
          homeItemLabel = 'Programación'
          this.customMonthNames = [
            'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
            'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
          ]
          this.customMonths = [
            {
              id:1,
              name:"Enero",
            },
            {
              id:2,
              name:"Febrero",
            },
            {
              id:3,
              name:"Marzo",
            },
            {
              id:4,
              name:"Abril",
            },
            {
              id:5,
              name:"Mayo",
            },
            {
              id:6,
              name:"Junio",
            },
            {
              id:7,
              name:"Julio",
            },
            {
              id:8,
              name:"Agosto",
            },
            {
              id:9,
              name:"Septiembre",
            },
            {
              id:10,
              name:"Octubre",
            },
            {
              id:11,
              name:"Noviembre",
            },
            {
              id:12,
              name:"Diciembre",
            }
          ]
          break
      }

      this.breadcrumbItems = [{ label: breadcrumbStep1ItemLabel1, disabled: true }]
      this.breadcrumbHomeItem = { label: homeItemLabel, routerLink: '/' + Routes.userClosedSales };


      if (!this.yearsList.includes(this.yearCalendar)) {
        this.yearsList.push(this.yearCalendar); // Agregar el año actual a yearsList si no está
      }

      if (this.monthIdSelected){
        this.monthNameSelected = this.getMonthSelected(this.monthIdSelected)

        //this.showChart = this.containId(this.programsYearInfo, this.monthIdSelected)
      }

      let currentYear = new Date().getFullYear()

      this.yearsList = this.createYearArray(2021, currentYear + 1);


    }

    let sortOptionItemLabel1 = 'Week from highest to lowest'
    let sortOptionItemLabel2 = 'Week from lowest to highest'
    let offerMenuItemLabel1 = 'See Offer'
    let offerMenuItemLabel2 = 'Add programme'

    if(this.profile) {
      switch(this.profile.lang) {
        case 'en':
          sortOptionItemLabel1 = 'Week from highest to lowest'
          sortOptionItemLabel2 = 'Week from lowest to highest'
          offerMenuItemLabel1 = 'See Offer'
          offerMenuItemLabel2 = 'Add programme'
          break
        case 'es':
          sortOptionItemLabel1 = 'Semana de mayor a menor'
          sortOptionItemLabel2 = 'Semana de menor a mayor'
          offerMenuItemLabel1 = 'Ver oferta'
          offerMenuItemLabel2 = 'Adicionar programación'
          break
      }
    }

    this.statuses = [
      { label: 'Created', value: 0 },
      { label: 'Pending Verify Pallets', value: 1 },
      { label: 'QC Pallets Verified', value: 2 },
      { label: 'Order Confirmed', value: 3 },
      { label: 'Payment Confirmed', value: 4 },
      { label: 'Cancelled', value: 5 }
    ];

    this.sortOptions = [
      { label: sortOptionItemLabel1, value: '!importOrder.closedSaleWeek' },
      { label: sortOptionItemLabel2, value: 'importOrder.closedSaleWeek' }
    ]

    this.offerMenuitems = [
      {
          label: offerMenuItemLabel1,
          command: () => {this.visibleExportOfferDialog = true}
      },
      {
          label: offerMenuItemLabel2,
          command: () => {this.visibleAddProgramationDialog = true}
      }
    ]

    this.loadCountries()
    this.loadImporters()
    this.loadCompanies(0) // Forwarders
    this.loadCompanies(1) // Custom Agents
    this.loadProgramInformation()

  }

  showOfferDetailDialog() {
    if(this.exportOfferId) {
      this._exportOfferService.getById(this.exportOfferId).subscribe({
        next: (v) => {
          this.exportOffer = v
          this.loading = false

          if(this.exportOffer.productCertificateTypes)
            this.selectedProductCertificateTypes = this.exportOffer.productCertificateTypes

          if(this.exportOffer.packagingTypes)
            this.selectedPackagingTypes = this.exportOffer.packagingTypes

          this.visibleExportOfferDialog = true
        },
        error: (e) => {
          this.loading = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.ExportOffer.ManyRetrieveError') })
        },
        complete: () => console.info('Export Offers query successfully')
      })
    }
  }


  loadImportOrders() {
    if(this.directSaleProgramId) {
      this.loading = true
      this._importOrderService.getAllClosedSale(
        this.directSaleProgramId,
        this.startWeek,
        this.endWeek,
        this.year
      ).subscribe({
        next: (v) => {
          this.exportOfferId = v.exportOfferId
          this.weekQueryDtos = v.weeks
          this.weekDtos = v.weeks
          this.directSaleStartWeek = v.startWeek
          this.directSaleEndWeek = v.endWeek
          this.directSaleStartYear = v.startYear
          this.directSaleEndYear = v.endYear
          this.getYears()
          this.loading = false

          this.filterLoads()
        },
        error: (e) => {
          this.loading = false
          this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar las ordenes.' });
        },
        complete: () => console.info('Import Order query successfully')
      })
    }
  }

  get startWeekValue() {
     return this.getAsFormatPeriod(this.directSaleStartWeek,this.directSaleStartYear);
  }

  get endWeekValue() {
    return this.getAsFormatPeriod(this.directSaleEndWeek ,this.directSaleEndYear);
 }

  addOrdersToWeek()
  {
    this.loading = true;
      let request: AddImportoOrderToProgramWeek = {
        directSaleProgramGuid: this.directSaleProgramId,
        week: this.selectedWeek,
        year: this.selectedYear,
        numberOrders: this.addContainersForm.controls['containersNumber'].value
      }

      this._importOrderService.addImportoOrderToProgramWeek(request).subscribe({
        next: (v) => {
          this._messageService.add({ severity: 'success',
          summary: this.translate.instant('MessageService.Summary.SuccessAction'),
          detail: this.translate.instant('MessageService.ImportOrder.CreateSuccess') })
          this.loading = false;
          this.visibleAddContainers = false;
          this.loadImportOrders();
          this.loadProgramYearInformation()
        },

        error: (e) => {
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.ImportOrder.CreateError') })
            this.loading = false;

        }
      })
  }

  showAddContainers(week: number, year: number, typeAdd: string)
  {
    this.selectedWeek = week;
    this.selectedYear = year;

    this.visibleAddContainers = true;

    if(typeAdd === 'container'){
      this.labelAdd = this.translate.instant('UserPages.UserClosedSale.ExporterClosedSaleOrders.AddOrderButton')
    }else{
      this.labelAdd = this.translate.instant('UserPages.UserClosedSale.ExporterClosedSaleOrders.AddPalletButton')
    }
  }

  getPalletPrice(detail: ImportOrderDetail): number {
    let total = 0

    if(detail.palletPrices)
    {
      detail.palletPrices.forEach(x => {
        total += x.price ? x.boxPerPallets * x.price : 0;
      })
      return total
    }
    return 0
  }

  onSortChange(event: any) {
    let value = event.value;

    if (value.indexOf('!') === 0) {
        this.sortOrder = -1;
        this.sortField = value.substring(1, value.length);
    } else {
        this.sortOrder = 1;
        this.sortField = value;
    }
  }

  getDetailTotalPrice(detail: ImportOrderDetail): number {
    return OrderUtils.getDetailTotalPrice(detail)
  }

  getMonthsOrder(array:ProgramYearSeries[]) {
    this.monthsOrder = array.map(item => item.monthNumber)
  }

  loadProgramYearInformation(firstSearch: boolean = false) {
    this.programsYearInfo = []
    this._directSaleProgramService.getProgramYearInformation(this.yearCalendar,this.directSaleProgramId).subscribe({
      next: (v) => {
        if(v.programYearSeries.length === 0 && firstSearch)
        {
          this.yearCalendar = v.year
          this.loadProgramYearInformation()
        }else{
          this.programsYearInfo = v.programYearSeries
          this.getMonthsOrder(v.programYearSeries)
          if(this.monthIdSelected)
          {

            this.programMonthInformation(this.programsYearInfo, this.monthIdSelected)

            this.showChart = this.containId(this.programsYearInfo, this.monthIdSelected)
          }

          this.positionCloseData()
          this.loading = false
        }

      },
      error: (e) => {
        console.log(e)
        this.loading = false
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar los países.' })
      },
      complete: () => console.info('ProgramYearInfo query successfully')
    })
  }

  loadProgramInformation() {
    this.programsYearInfo = []
    this._directSaleProgramService.getProgramInformation(this.directSaleProgramId).subscribe({
      next: (v) => {
          this.loading = false
          this.loadProgramRangeChartByMonth(v);

      },
      error: (e) => {
        console.log(e)
        this.loading = false
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar los países.' })
      },
      complete: () => console.info('ProgramYearInfo query successfully')
    })
  }

  openChartDialog() {
    this.visibleProgramChartDialog = true;
  }

  loadCountries() {
    this.countries = []
    this._countryService.getAll().subscribe({
      next: (v) => {
        this.countries = v
        this.loading = false
      },
      error: (e) => {
        console.log(e)
        this.loading = false
        this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar los países.' })
      },
      complete: () => console.info('Country query successfully')
    })
  }

  loadImporters() {
    this.importers = []
    if(this.profile) {
      this._profileService.getAllImportersByExporterId().subscribe({
        next: (v) => {
          this.importers = v
          this.loading = false
        },
        error: (e) => {
          console.log(e)
          this.loading = false
          this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar los importadores.'})
        },
        complete: () => console.info('Importers query successfully')
      })
    }
  }

  loadConsigneesNotifies() {
    this.loadConsignees()
    this.loadNotifies()
  }

  loadConsignees() {
    if(this.selectedImporter) {
      this._consigneeService.getAllForClosedSale(this.selectedImporter.id).subscribe({
        next: (v) => {
          this.consignees = v
          this.loading = false
        },
        error: (e) => {
          console.log(e)
          this.loading = false
          this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar los consignees.'})
        },
        complete: () => console.info('Consignees query successfully')
      })
    }
  }

  loadNotifies() {
    if(this.selectedImporter) {
      this._notifyService.getAllForClosedSale(this.selectedImporter.id).subscribe({
        next: (v) => {
          this.notifies = v
          this.loading = false
        },
        error: (e) => {
          console.log(e)
          this.loading = false
          this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar los notify.'})
        },
        complete: () => console.info('Notifies query successfully')
      })
    }
  }

  loadPorts() {
    if(this.formGroup.controls['importToCountryId'].value) {
      this._portService.getDestinationPortsByCountry(this.formGroup.controls['importToCountryId'].value).subscribe({
        next: (v) => {
          this.ports = v
        },
        error: (e) => {
          console.log(e)
          this.loading = false
          this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: 'No se pudieron recuperar los puertos de destino.' })
        },
        complete: () => console.info('Destination Ports query successfully')
      })
    }
  }

  saveClosedSale() {
    this.loading = true
    this.submit = true
    if(this.formGroup.valid && this.exportOffer) {

      if(!this.selectedImporter) {
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail:  this.translate.instant('MessageService.Importer.NullImporterError') })
        this.loading = false
        return
      }

      if(!this.selectedConsignee) {
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.Consignee.NullConsigneeError') })
        this.loading = false
        return
      }

      if(!this.selectedNotify) {
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.Notify.NullNotifyError') })
        this.loading = false
        return
      }

      let addOrderClosedSale: AddOrderClosedSaleRequest = {
        exportOfferId: this.exportOffer.id,
        importToCountryId: this.formGroup.controls['importToCountryId'].value,
        portToId: this.formGroup.controls['portToId'].value,
        importerId: this.selectedImporter.id,
        consigneeId: this.selectedConsignee.id ? this.selectedConsignee.id : 0,
        notifyId: this.selectedNotify.id ? this.selectedNotify.id : 0,
        palletsQuantity: this.formGroup.controls['palletQuantity'].value,
        week: this.formGroup.controls['startWeek'].value,
        year: this.formGroup.controls['startWeekYear'].value,
      }

      this._exportOfferService.addOrderClosedSale(addOrderClosedSale).subscribe({
        next: (v) => {
          this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: this.translate.instant('MessageService.ImportOrder.CreateSuccess') })
          this.submit = false
          this.loading = false
          this.visibleAddProgramationDialog = false
          this.loadImportOrders()
        },
        error: (e) => {
          this.submit = false
          this.loading = false
          console.log(e)
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.ImportOrder.CreateError') })
        },
        complete: () => console.info('Import Order to Closed Sale created successfully')
      })
    }
    else {
      this.loading = false
      this._messageService.add({ severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('MessageService.FormMessages.FormInvalid')})
    }
  }

  getFridgeStorages() {
    this.fridgeStorages = []
    this._fridgeStorageService.getAllByStorageType(1).subscribe({
      next: (v) => {
        this.fridgeStorages = v
      },
      error: (e) => {
        console.log(e)
        this.loading = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.FridgeStorage.ManyRetrieveError') })
      },
      complete: () => console.info('Fridge Storage query successfully')
    })
  }

  getErrorMessage(fieldName: string): string {
    return ErrorMessageUtil.getErrorMessage(this.formGroup, this.translate, fieldName, 20)
  }

  get totalPallets(): number {
    return this.formGroup.controls['palletQuantity'].value
  }

  get totalWeeks(): number {
    return 1
  }

  get containersPerWeek(): number {
    let pallets = this.formGroup.controls['palletQuantity'].value
    if(pallets && pallets % 20 == 0) {
      return pallets / 20
    }
    return 0
  }

  years: any[] = []
  getYears() {
    let current = new Date().getFullYear()
    let before = current -1;
    this.years.push({label: before, value: before})
    this.years.push({label: current, value: current})
    let next = current + 1
    this.years.push({label: next, value: next})
  }

  goToImportOrderDetail(orderId: any) {
    this._router.navigate(['/' + Routes.userClosedSaleImportOrderDetailPage, orderId, this.directSaleProgramId])
  }

  goToVerifyPalletsPage(detailId: any) {
    SessionVarUtils.removeVerifyPalletsIndex()
    this._router.navigate(['/' + Routes.userClosedSaleExporterVerifyPallets, detailId, this.directSaleProgramId])
  }

  changeYear(year:number){
    this.yearCalendar = year
    this.loadProgramYearInformation()
  }


   containId(array:any[], id:number) {
    return array.some(item => item.monthNumber === id)
   }

   showChart: boolean = false


   programMonthInformation(array:any[], monthId: number) {
    let programMonth = array.find(i => i.monthNumber === monthId);
    if(programMonth!==undefined){
      this.seriesProgram = programMonth.monthData.seriesProgram
      this.seriesLoad = programMonth.monthData.seriesLoad
      this.weeksChart = programMonth.monthData.weeks
    } else {
      this.seriesProgram = []
      this.seriesLoad = []
      this.weeksChart = []
    }
  }

  onMonthChange(event: any): void {
    console.log(event);
    this.monthIdSelected = event.month
    this.monthNameSelected = this.getMonthSelected(event.month)

    this.programMonthInformation(this.programsYearInfo, event.month)

    this.showChart = this.containId(this.programsYearInfo, event.month)

    if(this.yearCalendar != event.year){
      this.changeYear(event.year)
    }
    this.selectedMonth = event.month
    this.monthName = this.getMonthName(this.selectedMonth)
    this.startWeek = this.getFirstWeek(event.month - 1, event.year)
    this.endWeek = this.getLastWeek(event.month - 1, event.year)
    this.year = event.year
    this.loadImportOrders()

    let saveDate = new Date(event.year, event.month - 3, 1)
    sessionStorage.setItem('_close_sale_month', saveDate.toDateString());

  }

  onEditWeek(order: ImportOrder) {

    this.weekFormGroup.controls['importOrderId'].setValue(order.guid)
    this.weekFormGroup.controls['week'].setValue(order.closedSaleWeek)
    this.weekFormGroup.controls['year'].setValue(order.closedSaleWeekYear)
    this.editWeek = true
    this.visibleEditWeek = true
  }

  saveWeek() {
    this.loading = true
    this.submitWeekForm = true
    if(this.weekFormGroup.valid) {
      let request: ClosedSaleWeekRequest = {
        importOrderId: this.weekFormGroup.controls['importOrderId'].value,
        week: this.weekFormGroup.controls['week'].value,
        year: this.weekFormGroup.controls['year'].value
      }

      this._importOrderService.updateClosedSaleWeek(request).subscribe({
        next: (v) => {
          this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: 'Week saved successfully' })
          this.submitWeekForm = false
          this.loading = false
          this.editWeek = false
          this.visibleEditWeek = false;
          this.loadImportOrders()
          this.loadProgramYearInformation()
        },
        error: (e) => {
          this.submitWeekForm = false
          this.loading = false
          this.editWeek = false
          this.visibleEditWeek = false;
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: 'Week save error' })
        },
        complete: () => console.info('Import Order to Closed Sale created successfully')
      })
    }
    else {
      this.loading = false
    }

  }
   deleteOrder(orderId: string)
   {
     this._confirmationService.confirm({
      message: this.translate.instant('DeleteProgramOrderDialog.Message'),
      header: this.translate.instant('DeleteProgramOrderDialog.Header'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this._directSaleProgramService.deleteProgramOrder(orderId).subscribe({
          next: (v) => {
            this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: this.translate.instant('MessageService.DirectSaleProgram.DeleteProgramOrderSuccess') });
            this.loadImportOrders()
            this.loadProgramYearInformation()
          },
          error: (e) => {
            this.loading = false;
            let errorMessage = ''
            switch(this.profile?.lang) {
              case 'es':
                errorMessage = e.error.messageEs
                break
              case 'en':
                errorMessage = e.error.messageEn
                break
            }
            if(e.status === 400){
              this._messageService.add({ severity: 'error',
                summary: this.translate.instant('MessageService.Summary.FailedAction'),
                detail: errorMessage });
            }
            else {
              this._messageService.add({
                severity: 'error',
                summary: this.translate.instant('MessageService.Summary.FailedAction'),
                detail:this.translate.instant('MessageService.DirectSaleProgram.DeleteProgramOrderError') })
            }
          }
        })
      },
      reject: (type: any) => {
        switch (type) {
        case ConfirmEventType.REJECT:
            //this._messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Se canceló la eliminación' })
            break;
        case ConfirmEventType.CANCEL:
            //this._messageService.add({ severity: 'warn', summary: 'Cancelled', detail: 'Se canceló la eliminación' })
            break;
        }
      }
     })

   }
  loadVarieties() {
    this.varieties = []
    if(this.filterFormGroup.controls['speciesId'].value) {
      this._varietyService.getAllBySpecies(this.filterFormGroup.controls['speciesId'].value).subscribe({
        next: (v) => {
          this.varieties = v
          this.loading = false
        },
        error: (e) => {
          console.log(e)
          this.loading = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.Variety.ManyRetrieveError') })
        },
        complete: () => console.info('Variety query successfully')
      })
    }
  }

  loadSpeciesParams() {
    this.selectedSpecies = this.species.find(x => x.id === this.filterFormGroup.controls['speciesId'].value)
    this.loadVarieties()
  }

  getSpeciesName(species: Species): string {
    if(this.profile)
      return SpeciesUtils.getSpeciesName(this.profile.lang, species)
    return ''
  }

  onChangeVariety() {
    this.selectedVariety = this.varieties.find(x => x.id === this.filterFormGroup.controls['varietyId'].value)
  }

  getFirstWeek(month: number, year: number): number {
    return moment().month(month).year(year).startOf('month').week()
  }

  getLastWeek(month: number, year: number): number {
    let first = moment().month(month).year(year).startOf('month').week()
    let last = moment().month(month).year(year).endOf('month').week()

    return (month == 11 && last < first) ? 52 : last
  }

  getWeekNumber(day: number, month: number, year:number): boolean {
    const date = new Date(year,month, day)

    var weekNumber = ProgramRequestUtil.ISO8601_week_no(date)

    let weekFormat = this.getAsFormatPeriod(weekNumber, year)

    return (weekFormat >= this.startWeekValue) && (weekFormat <= this.endWeekValue)

  }

  getDateFromWeek(week: number, year: number) {
    return moment().day("Monday").year(year).week(week).toDate();
  };


  getLength(value: number): number {
     return value.toString().length;
  }

  getAsFormatPeriod(weekNumber: number, year: number ): number {
      let digits = this.getLength(weekNumber);

      let weekNumberString = weekNumber.toString()

      if(digits <= 1){

         weekNumberString = this.zeroPad(weekNumber, 2)
      }

      let periodString = year.toString() + weekNumberString.toString()
      return parseInt(periodString);
  }

  zeroPad(num: number, places: number) {
    var zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join("0") + num;
  }

  onFilter() {
    this.loading = true
    this.weekDtos = this.weekQueryDtos

    const week = this.filterFormGroup.controls['week'].value

    if(week) {
      this.weekDtos = this.weekDtos.filter(x => x.week === week)
    }

    const speciesId = this.filterFormGroup.controls['speciesId'].value
    if(speciesId) {
      let filtered:ClosedSaleWeek[]  = []
      this.weekDtos.forEach(w => {
        let week: ClosedSaleWeek = {
          importOrdersDtos: [],
          week: w.week,
          year: w.year,
          startWeek: w.startWeek,
          endWeek: w.endWeek,
          endYear: w.endYear,
          startYear: w.startYear
        }
        w.importOrdersDtos.forEach(i => {
          i.details.forEach(d => {
            if(d.speciesId == speciesId)
              week.importOrdersDtos.push(i)
          })
        })
        if(week.importOrdersDtos.length > 0)
          filtered.push(week)
      })
      this.weekDtos = filtered
    }

    const varietyId = this.filterFormGroup.controls['varietyId'].value
    if(varietyId) {
      let filtered:ClosedSaleWeek[]  = []
      this.weekDtos.forEach(w => {
        let week: ClosedSaleWeek = {
          importOrdersDtos: [],
          week: w.week,
          year: w.year,
          startWeek: w.startWeek,
          endWeek: w.endWeek,
          endYear: w.endYear,
          startYear: w.startYear
        }
        w.importOrdersDtos.forEach(i => {
          i.details.forEach(d => {
            if(d.varietyId == varietyId)
              week.importOrdersDtos.push(i)
          })
        })
        if(week.importOrdersDtos.length > 0)
          filtered.push(week)
      })
      this.weekDtos = filtered
    }

    const fridgeStorageId = this.othersFiltersForm.controls['fridgeStorageId'].value;
    const harvestDate = this.othersFiltersForm.controls['harvestDate'].value;
    const price = this.othersFiltersForm.controls['price'].value;
    const shelfLife = this.othersFiltersForm.controls['shelfLife'].value;
    const speciesSize = this.othersFiltersForm.controls['speciesSize'].value;
    const kilosPerBox = this.othersFiltersForm.controls['kilosPerBox'].value;

    let filteredOthers:ClosedSaleWeek[] = []

    this.weekDtos.forEach(
      (week) => {

      let weekNew: ClosedSaleWeek = {
        importOrdersDtos: [],
        week: week.week,
        year: week.year,
        startWeek: week.startWeek,
        endWeek: week.endWeek,
        endYear: week.endYear,
        startYear: week.startYear
      }

      week.importOrdersDtos.forEach(i => {
            let priceFilter = true;
            let harvestFilter = true;
            let speciesSizeFilter = true;
            let kilosPerBoxFilter = true;
            let shelfLifeFilter = true;
            let fridgeStorageFilter = true;
            i.details.forEach(d => {

              if(price)
                {
                  let findPrice = d.palletPrices?.find(x => x.price == price);
                  priceFilter = findPrice || d.price == price ? true : false;
                }

              if(harvestDate)
                {
                  let registerDate = new Date(d.harvestDate)
                  let selectedDate = new Date(harvestDate)
                  harvestFilter = (registerDate.getDay() == selectedDate.getDay() &&
                                   registerDate.getMonth() == selectedDate.getMonth()  &&
                                   registerDate.getFullYear() == selectedDate.getFullYear()
                                  )
                }

              if(shelfLife)
                {
                  shelfLifeFilter = d.shelfLife = shelfLife
                }

              if(kilosPerBox)
                {
                  kilosPerBoxFilter = d.exportOffer.kilosPerBox = kilosPerBox
                }

              if(speciesSize)
                {
                  let findSpeciesSize = d.palletPrices?.find(x => x.speciesSize == speciesSize);

                  speciesSizeFilter = findSpeciesSize || d.exportOffer.speciesSize == speciesSize ? true : false;
                }

              if(fridgeStorageId)
                {
                  fridgeStorageFilter = d.fridgeStorageId = fridgeStorageId;
                }
          });

            if(priceFilter &&
              speciesSizeFilter &&
              kilosPerBoxFilter &&
              shelfLifeFilter &&
              harvestFilter &&
              fridgeStorageFilter){
                weekNew.importOrdersDtos.push(i)
              }

          });

          if(weekNew.importOrdersDtos.length > 0)
            {
              filteredOthers.push(weekNew)
            }
      });

    this.weekDtos = filteredOthers;
    this.loading = false;
  }

  onClearFilter() {
    this.filterFormGroup.controls['week'].setValue(null)
    this.filterFormGroup.controls['speciesId'].setValue(null)
    this.filterFormGroup.controls['varietyId'].setValue(null)
    this.weekDtos = this.weekQueryDtos
  }

  getImageUrl(offer: ExportOffer): string {
    return offer.offerPictures && offer.offerPictures.length > 0 ? environment.apiUrl + offer.offerPictures[0].url : ''
  }

  get totalPrice() {
    let total = 0
    if(this.weekDtos) {
      this.weekDtos.forEach(x => {
        x.importOrdersDtos.forEach(i => {
        // Tiene en cuenta el estado para sumar según lo esperado o lo realmente cargado
          if(i.importOrder.status === 3 || i.importOrder.status === 4  ){
             i.details.forEach(d => {
              total += this.getTotalPriceConfig(d.palletPrices ?? []);
             })
          }else{
            i.details.forEach(d => {
              total += d.caseQuantityPerPallet * d.price * d.palletsQuantity
            })
          }

        })
      })
    }
    return total
  }

  getTotalPriceConfig(priceConfig: PalletPrice[]): number
  {
      let total = 0;
      priceConfig.forEach((x) => {
        total += x.boxPerPallets * (x.price ?? 0)
      })

      return total;
  }

  getAddLabel(){

  }

  get totalBoxes() {
    let total = 0
    if(this.weekDtos) {
      this.weekDtos.forEach(x => {
        x.importOrdersDtos.forEach(i => {
          // Tiene en cuenta el estado para sumar según lo esperado o lo realmente cargado
          i.details.forEach(d => {
            if(i.importOrder.status === 3 || i.importOrder.status === 4 ){
              total += d.caseQuantityPerPallet;
            }else{
              total += d.caseQuantityPerPallet * d.palletsQuantity
            }

          })
        })
      })
    }
    return total
  }

  setVisibleOrderDetail(order: ImportOrderInformation) {
    if (order) {
      order.expanded = !order.expanded
    }
  }

  get totalPalletsHistoric() {
    let total = 0
    if(this.weekDtos) {
      this.weekDtos.forEach(x => {
        x.importOrdersDtos.forEach(i => {
          i.details.forEach(d => {
            total += d.palletsQuantity
          })
        })
      })
    }
    return total
  }

  // Se cambia para calcular 1 orden = 1 contenedor
  get totalContainers() {
    let total = 0
    if(this.weekDtos) {
      this.weekDtos.forEach(x => {
        x.importOrdersDtos.forEach(i => {
          total++
        })
      })
    }
    return total
  }

  showCurrentPalletPriceModal(detail: ImportOrderDetail) {
      // this.calculateTablePrice()
      this.currentPrices = detail.palletPrices ? detail.palletPrices : []
      this.visibleCurrentPalletsPrice = true
      this.priceView = true
  }

  showCurrentCasesPerPallet(detail: ImportOrderDetail){
    this.palletCases = detail.palletCaseConfig ? detail.palletCaseConfig : []
    this.visibleCurrentPalletsCases = true
  }

  getStatusSeverity(status: number): string {
    if (status === 1 || status === 2) {
      return 'warning';
    } else if (status === 3 || status === 4) {
      return 'success';
      } else if(status === 5){
        return 'error';
    } else {
      return 'info';
    }
  }

  getStatusIcon(status: number): string {
    if (status === 0 || status === 1 || status === 2) {
      return 'pi pi-exclamation-triangle';
    } else if (status === 3 || status === 4) {
      return 'pi pi-check';
    } else {
      return 'pi pi-times';
    }
  }

  loadCompanies(type: number) {
    this._companyService.getAllByCompanyType(type).subscribe({
      next: (v) => {
        if (type === 0) this.companyForwarders = v
        if (type === 1) this.companyCustomAgents = v
      },
      error: (e) => {
        console.log(e)
        let erroMessage = ''
        if (type === 0) erroMessage = this.translate.instant('ForwarderPage.Messages.ErrorLoadForwarders')
        if (type === 1) erroMessage = this.translate.instant('CustomAgentPage.Messages.ErrorLoadCustomAgents')
        this._messageService.add({ severity: 'error', summary: this.translate.instant('MessageService.Summary.FailedAction'), detail: erroMessage });
      },
      complete: () =>  {
        this.loading = false
        console.info('Company query successfully')
      }
    })
  }

  onAssignForwarder(order: ImportOrder) {
    this.visibleAssignForwarderDialog = true
    this.selectedOrderGuid = order.guid
  }

  assignForwarder() {
    if (this.selectedCompanyForwarder && this.selectedOrderGuid)
    {
      let importOrderId = this.selectedOrderGuid
      let company = this.selectedCompanyForwarder
      this._confirmationService.confirm({
        message: this.translate.instant('ForwarderPage.QuestionAssignForwarder'),
        header: this.translate.instant('ForwarderPage.TitleSection'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this._importOrderService.assingForwarder(importOrderId, company).subscribe({
            next: (v) => {
              this.loadImportOrders()
              this.visibleAssignForwarderDialog = false
              this.loading = false
              this._messageService.add({ severity: 'success', summary: this.translate.instant('MessageService.Summary.SuccessAction'), detail: this.translate.instant('ForwarderPage.SuccessAssignForwarder') });
            },
            error: (e) => {
              console.log(e)
              this.loading = false
              this._messageService.add({ severity: 'error', summary: this.translate.instant('MessageService.Summary.FailedAction'), detail: this.translate.instant('ForwarderPage.ErrorAssignForwarder') });
            },
            complete: () => {
              this.loading = false
              console.info('Forwarder assigned successfully')
            }
          })
        },
        reject: (type: any) => {}
      })
    }
  }

  onAssignCustomAgent(order: ImportOrder) {
    this.visibleAssignCustomAgentDialog = true
    this.selectedOrderGuid = order.guid
  }

  assignCustomAgent() {
    if (this.selectedCompanyCustomAgent && this.selectedOrderGuid)
    {
      let importOrderId = this.selectedOrderGuid
      let company = this.selectedCompanyCustomAgent
      this._confirmationService.confirm({
        message: this.translate.instant('CustomAgentPage.QuestionAssignCustomAgent'),
        header: this.translate.instant('CustomAgentPage.TitleSection'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this._importOrderService.assingCustomAgent(importOrderId, company).subscribe({
            next: (v) => {
              this.loadImportOrders()
              this.visibleAssignCustomAgentDialog = false
              this.loading = false
              this._messageService.add({ severity: 'success', summary: this.translate.instant('MessageService.Summary.SuccessAction'), detail: this.translate.instant('CustomAgentPage.SuccessAssignCustomAgent') });
            },
            error: (e) => {
              console.log(e)
              this.loading = false
              this._messageService.add({ severity: 'error', summary: this.translate.instant('MessageService.Summary.FailedAction'), detail: this.translate.instant('CustomAgentPage.ErrorAssignCustomAgent') });
            },
            complete: () => {
              this.loading = false
              console.info('Custom Agent assigned successfully')
            }
          })
        },
        reject: (type: any) => {}
      })
    }
  }

  getIconUrl(iconUrl: string | undefined): string {
    return iconUrl ? iconUrl : ''
  }

  getMonthName(monthNumber: number) {
    switch(this.profile?.lang) {
      case 'en':
        moment.locale('en')
        break
      case 'es':
        moment.locale('es')
        break
    }
    var month = moment().month(monthNumber - 1).format('MMMM')
    return month.charAt(0).toUpperCase() + month.slice(1);
  }

  monthsOrder: any[] = []
  monthIdSelected: number | undefined
  monthNameSelected: string | undefined
  selectedDate: Date = new Date();

  yearCalendar: number = new Date().getFullYear()


  yearsList: number[] = []

  handleMonths(month: string,  index: number): void {
    this.monthIdSelected = index
    this.monthNameSelected = month
    this.dateCalendar = new Date(this.yearCalendar, index-1, this.dateCalendar.getDate()); // Cambia solo el mes, respeta el año
    this.programMonthInformation(this.programsYearInfo, index)

    this.showChart = this.containId(this.programsYearInfo, index)

    this.selectedMonth = this.monthIdSelected
    this.monthName = this.getMonthName(this.selectedMonth)
    this.startWeek = this.getFirstWeek(this.selectedMonth -1, this.yearCalendar)
    this.endWeek = this.getLastWeek(this.selectedMonth -1, this.yearCalendar)
    this.year = this.yearCalendar

    this.loadImportOrders()

    let saveDate = new Date(this.yearCalendar, this.selectedMonth - 1, 1)
    sessionStorage.setItem('_close_sale_month', saveDate.toDateString());

  }

  selectClassMonth(index: number): string {
    if (this.monthIdSelected === index) {
      return 'chip-selected';
    } else if (this.monthsOrder.includes(index)) {
      return 'chip-pre-selected';
    }
    return '';
  }

  onYearChange(event: any): void {
    const currentDay = this.dateCalendar.getDate(); // Guarda el día actual

    if(this.monthIdSelected){
      this.dateCalendar = new Date(this.yearCalendar, this.monthIdSelected-1, currentDay);
      let saveDate = new Date(this.yearCalendar, this.monthIdSelected-1, 1)
      sessionStorage.setItem('_close_sale_month', saveDate.toDateString());
    }
    this.loadProgramYearInformation()
    this.year = this.yearCalendar
    this.loadImportOrders()
  }

  getInitialLetters(value: string): string {
    return value ? value.substring(0, 3) : '';
  }


  filterLoads() {
    if (!this.searchTerm.trim()) {
      this.filteredRegisters = this.weekDtos;
    } else {
      this.filteredRegisters = this.weekDtos.filter(product =>
        this.filterLoadsFunction(product)
      );
    }
  }

  filterLoadsFunction(product: ClosedSaleWeek): boolean
  {
    var hasDetail = product.importOrdersDtos.some(order =>
      order.details.some(detail =>
        detail.variety?.name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        detail.variety?.species.name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        detail.variety?.species.nameEs.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        detail.importOrder?.sequence?.toString().toLowerCase().includes(this.searchTerm.toLowerCase())
      )
    )

    var hasBlInfo = product.importOrdersDtos.some(order =>
        order.delivery?.deliveryInstructions?.toLocaleLowerCase().includes(this.searchTerm.toLowerCase()) ||
        order.delivery?.containerNumber?.toLocaleLowerCase().includes(this.searchTerm.toLowerCase()) ||
        order.importOrder.id?.toLocaleLowerCase().includes(this.searchTerm.toLowerCase())
    )

    return hasDetail || hasBlInfo;
  }

  createYearArray(startYear: number, endYear: number): number[] {
    const yearArray: number[] = [];
    for (let year = startYear; year <= endYear; year++) {
      yearArray.push(year);
    }
    return yearArray;
  }

  positionCloseData()
  {
    let maxMonth: number = 1
    if(this.programsYearInfo.length > 0 && !this.validatePositionMonthData())
    {
      this.programsYearInfo.forEach((x) => {
         if(x.monthNumber > maxMonth)
         {
          maxMonth = x.monthNumber;
         }
      })

      if(this.monthIdSelected != maxMonth)
      {
        this.monthIdSelected == maxMonth
        this.selectedMonth = maxMonth
      }
      this.year = this.yearCalendar
      this.startWeek = this.getFirstWeek(this.selectedMonth, this.yearCalendar)
      this.endWeek = this.getLastWeek(this.selectedMonth, this.yearCalendar)
      this.dateCalendar = this.getDateFromWeek(this.startWeek, this.yearCalendar)
    }
    this.loadImportOrders()
  }

  validatePositionMonthData()
  {
    if(this.monthIdSelected){
      return this.programsYearInfo.some(x => x.monthNumber == this.monthIdSelected)
    }

    return false

  }

    getTotalPallets()
  {
    return this.palletCases.reduce((acc, item) => acc + item.pallets, 0);
  }

    getTotalCases()
  {
    return this.palletCases.reduce((acc, item) => acc + item.boxesPerPallets, 0);
  }

  validateDeleteProgram(orderId: string)
  {
    this.loading = true;
    this.selectedOrderGuid = orderId;
    this._directSaleProgramService.validateDeleteProgramOrder(orderId).subscribe({
      next: (v) => {
        if(!v.allowDelete)
        {
          this.orderSequence = v.notAllowDeleteId;
          this.orderGuid = v.notAllowGuid;
          this.visibleValidationDelete = true;
        }else
        {
          this.deleteOrder(orderId);
        }

        this.loading = false;
      },
      error: (e) => {
        this.loading = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.DirectSaleProgram.ValidateDeleteProgramError') })
      }
    })
  }

  goToOrderDetail()
  {
    if(this.selectedOrderGuid)
    {
      this.goToImportOrderDetail(this.selectedOrderGuid);
    }
  }

  onToggleDetail(dto: ClosedSaleWeek)
  {
    dto.expanded = !dto.expanded;
  }
}
